import React from 'react'
import styled from 'styled-components'

import './colors.module.scss'
import './fonts.module.scss'
import './base.module.scss'

const StyledGlobals = styled.div`
font-family:var(--font-noto);
font-size:1.8rem;
line-height: 3rem;

`

export const Globals: React.FC = ({ children }) => {
    return <StyledGlobals>{children && children}</StyledGlobals>
}
